import {
  Preferences,
  GET_PREFERENCES,
  SET_PREFERENCES,
  UPDATE_PREFERENCES,
  GET_SETTINGS,
  SET_SETTINGS,
  CHANGE_ACCOUNT_TYPE,
  Settings,
  SEND_CONTACT_FORM,
  Form,
} from './types';

export const getPreferences = () => ({ type: GET_PREFERENCES });

export const setPreferences = (preferences: Preferences) => ({
  type: SET_PREFERENCES,
  preferences,
});

export const updatePreferences = (preferences: Preferences) => ({
  type: UPDATE_PREFERENCES,
  preferences,
});

export const getSettings = () => ({ type: GET_SETTINGS });

export const setSettings = (settings: Settings) => ({
  type: SET_SETTINGS,
  settings,
});

export const sendContactForm = (form: Form) => ({
  type: SEND_CONTACT_FORM,
  form,
});

export const changeAccountType = () => ({
  type: CHANGE_ACCOUNT_TYPE,
});
